import { useSelector } from 'react-redux';

import { makeGetCurrentTeamUrl, makeGetCurrentTeam } from 'selectors/teams';
import { makeGetCurrentPlanId } from 'selectors/billing';

import { getPlanById } from 'utils/plan';

const getCurrentTeamUrl = makeGetCurrentTeamUrl();

export const useCurrentTeamUrl = () => {
    const currentTeamUrl = useSelector(({ teams }) => getCurrentTeamUrl(teams));

    return currentTeamUrl;
};

const getCurrentTeam = makeGetCurrentTeam();

export const useCurrentTeam = () => {
    const currentTeam = useSelector(({ teams }) => getCurrentTeam(teams));

    return currentTeam;
};

export const useCurrentTeamId = () => {
    const currentTeam = useSelector(({ teams }) => getCurrentTeam(teams));

    return currentTeam?.id;
};

const getCurrentPlanId = makeGetCurrentPlanId();

export const useCurrentPlanId = () => {
    const currentTeam = useSelector(({ teams }) => getCurrentTeam(teams));

    return getCurrentPlanId(currentTeam);
};

export const useCurrentPlanProps = () => {
    const currentPlanId = useCurrentPlanId();

    return getPlanById(currentPlanId);
};
